/* @flow */

import tracking from 'dibs-tracking';

import {
    getMatchmakerReferrer,
    deleteMatchmakerReferrer,
} from '../shared/helpers/matchmakerReferrer';

type TrackEventParams = {
    label: string,
    category?: string,
    action?: string,
};

const trackEvent = (params: TrackEventParams) => {
    // category & action params should be over-writeable defaults
    tracking.trackEvent({
        category: 'design features',
        action: 'designer connection',
        ...params,
    });
};

export const trackPageview = () => {
    // Designer connection links leading here store the value of click origin in sessionStorage
    const clickOrigin = getMatchmakerReferrer();

    if (clickOrigin) {
        trackEvent({ label: `form entry | ${clickOrigin}` });
        deleteMatchmakerReferrer();
    }

    tracking.trackPageview({
        additional: {
            pageType: 'Other',
            pageSubType: 'Other',
        },
    });
};

export const trackGetStartedClick = () => {
    trackEvent({
        category: 'trade features',
        label: 'get started clicked',
    });
};

export const trackNextClick = () => {
    trackEvent({ label: 'next button clicked' });
};

export const trackNotMatchingClick = () => {
    trackEvent({ label: 'do not match preferences clicked' });
};

export const trackSendInformationClick = () => {
    trackEvent({ label: 'send information clicked' });
};

export const trackSendInformationComplete = () => {
    trackEvent({ label: 'project information submitted' });
};

export const trackLoginEntry = () => {
    tracking.trackEvent({
        category: 'login',
        action: 'login entry',
        label: 'submit project information',
    });
};

export const trackLoginComplete = () => {
    tracking.trackEvent({
        category: 'login',
        action: 'login complete',
        label: 'submit project information',
    });
};
